<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <jhs-free-heading/>
        <section class="l-section">
            <heading-bg title="申し込みできません"/>
            <div class="l-element">
                <p class="m-text-normal is-primary is-text-center is-text-bold is-mgb0">審査結果のメールを確認してね！</p>
            </div>
            <div class="l-element">
                <p class="m-text-normal is-mgb0">
                    お客様は以前に本サービスにお申込み頂いた際の審査結果において「非承認」となりましたので、再度お申込み頂くことができません。<br/>
                    <br/>
                    詳しくは審査結果メールの内容にてご確認ください。
                </p>
            </div>
        </section>
        <div class="l-element">
            <btn @click="onClickTopButton" text="ピクトリンクTOPへ" :priority="cssPriority.SECONDARY" data-jest="top-link"/>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import HeadingBg from "../../atoms/HeadingBg.vue";
import Btn from "../../atoms/Btn.vue"
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import {cssPriority} from "../../../view-model/enum/CSSPriority";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import {mapGetters} from "vuex";
import {moveToTopPage} from "./common/jhsFreeLinkUtils";

export default {
    name: "JhsFreeErrorEntryDenial",
    components: {BaseLayout, JhsFreeHeading, HeadingBg, Btn},
    props: {
        /**
         * titleタグ
         */
        title: {
            type: String,
            required: true
        },
        /**
         * meta description
         */
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            cssPriority: cssPriority,
        }
    },
    computed: {
        ...mapGetters('AccountStoreV2', [
            'isAppli'
        ]),
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        onClickTopButton(){
            moveToTopPage(this.isAppli,'ピクトリンクTOPへ')
        }
    },
    mounted() {
        this.setTitleAndDesc()
    }
}
</script>
